import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DeviceService } from "./device.service";
import { Router } from "@angular/router";

declare var $;

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.css'],
  providers: [
    DeviceService
  ]
})
export class DeviceComponent implements OnInit {

  title: string;

  isLoading: boolean;
  filterParams: any;
  totalPage: number;
  deviceList: any;
  deviceInfo: any;
  totalElements: number;

  //watch variable change
  differ: any;
  constructor(
    private deviceService: DeviceService,
    private differs: KeyValueDiffers,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.title = "Device";
    this.filterParams = {
      size: 10,
      page: 0
    };
  }

  ngDoCheck() {
    var change = this.differ.diff(this.filterParams);
    if (change) {
      if (this.filterParams.page < 0) {
        this.filterParams.page = 0;
        return;
      } else if (this.filterParams.page > this.totalPage - 1) {
        this.filterParams.page = this.totalPage - 1;
        return;
      }
      this.getDeviceList();
    }
  }

  getDeviceList() {

    this.isLoading = true;
    this.deviceService.getDeviceList(this.filterParams)
      .then(res => {
        if( res.status === 1 )
        {
          this.deviceList = res.data.dataList;
          this.totalElements = res.data.totalElements;
          this.initPaginate();
          this.isLoading = false;
        } else {
          this.toastr.error(res.message , 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        
      })
      .catch(err => console.log(err));
  }

  //init paging 
  initPaginate() {
    this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
    let arrPagingNumber = [];
    for (let i = 0; i < this.totalPage; i++) {
      arrPagingNumber.push(i);
    }
    return arrPagingNumber;
  }

  showBoard(device: any){
    this.deviceInfo = device;
    $('#myModal').modal('show');
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/device/device.component.ts